// Support header component for the support page.

import Logo from '@components/atoms/images/supportLogo';
import Subtitle from '@components/atoms/text/supportSubtitle';
import TranslationManager from '@shared/assets/locale/translationsManager';
import { useMemo } from 'react';

const LITERALS = 'PAGES.SETTINGS.SUPPORT';

/**
 * Support header component for the support page.
 * Displays the flavour logo and the subtitle.
 *
 * @returns {JSX.Element} Support header component
 */
export default function SupportHeader() {
  const subtitle = useMemo(
    () => TranslationManager.get(`${LITERALS}.SUBTITLE`),
    []
  );

  return (
    <>
      <Logo />
      <Subtitle>{subtitle}</Subtitle>
    </>
  );
}
